import { reactive } from 'vue';
import { tiposEscolaridadeService } from '../service/tipos-escolaridade-service';
import { tiposEstadoCivilService } from '../service/tipos-estado-civil-service';
import { tiposRacaService } from '../service/tipos-raca-service';
import { tiposSexoServie } from '../service/tipos-sexo-service';
import { selectUtils } from '../util/select.utils.js';

export const camposSocioStore = reactive({
    tiposEscolaridade: null,
    tiposSexo: null,
    tiposRaca: null,
    tiposEstadoCivil: null,
    isLoadingTiposEscolaridade: false,
    isLoadingTiposSexo: false,
    isLoadingTiposRaca: false,
    isLoadingTiposEstadoCivil: false,

    async adquirirTodosOsCampos() {
        if (this.tiposEscolaridade === null) {
            await this.atualizarTiposEscolaridade();
        }
        if (this.tiposSexo === null) {
            await this.atualizarTiposSexo();
        }
        if (this.tiposRaca === null) {
            await this.atualizarTiposRaca();
        }
        if (this.tiposEstadoCivil == null) {
            await this.atualizarTiposEstadoCivil();
        }
    },

    async atualizarTiposEscolaridade(tiposEscolaridadeNovo) {
        if(this.isLoadingTiposEscolaridade) return;

        if (!!tiposEscolaridadeNovo && this.tiposEscolaridade != tiposEscolaridadeNovo) {
            this.tiposEscolaridade = tiposEscolaridadeNovo;
        } else if (!!!tiposEscolaridadeNovo && !!!this.tiposEscolaridade) {
            this.isLoadingTiposEscolaridade = true; 
            const listaTipos = await tiposEscolaridadeService.listar();
            this.tiposEscolaridade = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','descricao']]
            });
            this.isLoadingTiposEscolaridade = false;

        }
        return this.tiposEscolaridade;
    },

    async atualizarTiposSexo(tiposSexoNovo) {
        if(this.isLoadingTiposSexo) return;

        if (!!tiposSexoNovo && this.tiposSexo != tiposSexoNovo) {
            this.tiposSexo = tiposSexoNovo;
        } else if (!!!tiposSexoNovo && !!!this.tiposSexo) {
            this.isLoadingTiposSexo = true;
            const listaTipos = await tiposSexoServie.listar();
            this.tiposSexo = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','descricao']]
            });
            this.isLoadingTiposSexo = false;
        }
        return this.tiposSexo;
    },

    async atualizarTiposRaca(tiposRacaNovo) {
        if(this.isLoadingTiposRaca) return;

        if (!!tiposRacaNovo && this.tiposRaca != tiposRacaNovo) {
            this.tiposRaca = tiposRacaNovo;
        } else if (!!!tiposRacaNovo && !!!this.tiposRaca) {
            this.isLoadingTiposRaca = true;
            const listaTipos = await tiposRacaService.listar();
            this.tiposRaca = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','descricao']]
            });
            this.isLoadingTiposRaca = false;
        }
        return this.tiposRaca;
    },

    async atualizarTiposEstadoCivil(tiposEstadoCivilNovo) {
        if(this.isLoadingTiposEstadoCivil) return;

        if (!!tiposEstadoCivilNovo && this.tiposEstadoCivil != tiposEstadoCivilNovo) {
            this.tiposEstadoCivil = tiposEstadoCivilNovo;
        } else if (!!!tiposEstadoCivilNovo && !!!this.tiposEstadoCivil) {
            this.isLoadingTiposEstadoCivil = true;
            const listaTipos = await tiposEstadoCivilService.listar();
            this.tiposEstadoCivil = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','descricao']]
            });
            this.isLoadingTiposEstadoCivil = false;
        }
        return this.tiposEstadoCivil;
    },
})